// Verified nutrition helpers: serving maths, schema.org block and ingredient-based allergen fallback.
export const ALLERGEN_ORDER = ["Gluten", "Dairy", "Tree nuts", "Egg", "Celery", "Mustard", "Sulphites"];
export const ALLERGEN_DOT = { Gluten: "bg-amber-500", Dairy: "bg-sky-500", "Tree nuts": "bg-orange-700", Egg: "bg-yellow-400", Celery: "bg-lime-600", Mustard: "bg-yellow-600", Sulphites: "bg-purple-500" };

export const SERVINGS = [
  { id: "serving", label: "Per slice / serving" },
  { id: "whole", label: "Whole dish" },
  { id: "100g", label: "Per 100 g" },
];

const round = (v, d = 1) => (v == null ? null : Math.round(v * 10 ** d) / 10 ** d);

export function nutritionValues(n, mode) {
  if (!n) return null;
  const div = mode === "whole" ? 1 : mode === "100g" ? n.baked_weight_g / 100 : n.slices || 1;
  const kcal = mode === "whole" ? n.kcal_whole : mode === "100g" ? n.kcal_per_100g : n.kcal_per_slice;
  return {
    grams: Math.round(n.baked_weight_g / div), kcal,
    protein: round(n.protein_g == null ? null : n.protein_g / div), carbs: round(n.carbs_g == null ? null : n.carbs_g / div),
    fat: round(n.fat_g == null ? null : n.fat_g / div), sodium: round(n.sodium_mg == null ? null : n.sodium_mg / div, 0),
    fiber: round(n.fiber_g == null ? null : n.fiber_g / div),
  };
}

export function servingNote(n, mode) {
  if (!n || mode !== "serving") return mode === "100g" ? "per 100 g" : "whole dish";
  return n.slices > 1 ? `1 of ${n.slices} ${n.slices === 2 ? "halves" : n.slices === 6 ? "sticks" : "slices"}` : "1 serving";
}

export function schemaNutrition(n) {
  const v = nutritionValues(n, "serving");
  if (!v) return undefined;
  const out = { "@type": "NutritionInformation", servingSize: `1 ${n.slices > 1 ? "slice" : "serving"} (${v.grams}g)`, calories: `${v.kcal} calories` };
  [["protein", "proteinContent", "g"], ["carbs", "carbohydrateContent", "g"], ["fat", "fatContent", "g"], ["fiber", "fiberContent", "g"], ["sodium", "sodiumContent", "mg"]]
    .forEach(([k, f, u]) => { if (v[k] != null) out[f] = `${v[k]} ${u}`; });
  return out;
}

const GLUTEN_CATEGORIES = ["roman", "focaccia_paninis", "lasagna", "anti_pasti"];

const RULES = [
  ["Gluten", /dough|focaccia|pasta|lasagna|savoiardi|bread|flour|béchamel|bachemel/i],
  ["Dairy", /mozzarella|burrata|parmesan|cheese|cheddar|paneer|butter|cream|mascarpone|ranch|béchamel|bachemel|4 dips/i],
  ["Tree nuts", /walnut|almond|romesco|pesto|4 dips/i],
  ["Egg", /\begg|frittata|savoiardi|ladyfinger|tiramisu/i],
  ["Celery", /celery/i],
  ["Mustard", /mustard/i],
];

export function itemAllergens(it) {
  if (it.nutrition) return it.nutrition.allergens;
  const text = [...(it.ingredients || []), it.description || "", it.name || ""].join(" | ").replace(/egg-?free|eggless/gi, "");
  const found = RULES.filter(([, rx]) => rx.test(text)).map(([a]) => a);
  if (GLUTEN_CATEGORIES.includes(it.category) && !found.includes("Gluten")) found.push("Gluten");
  return found;
}
